var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m982.5 697.87c-28.125-28.125-66.75-41.625-106.5-37.5s-74.625 25.875-96.375 59.625l-11.25 17.25c-18 28.5-54.75 39.75-87.375 27-116.62-45.75-197.26-127.87-245.63-251.63-11.625-29.625 0.375-64.125 28.875-82.5l15.75-10.125c33.375-21.375 55.125-56.25 59.625-96 4.125-39.75-9.375-78.375-37.875-106.88l-86.625-86.625c-45.375-45.375-116.25-51.375-168.74-14.25l-73.875 52.875c-70.5 50.25-98.625 141-68.25 220.87 129.37 340.5 366.74 577.87 706.13 706.13 21.375 7.875 43.5 12 65.25 12 60 0 118.12-28.875 154.87-80.25l52.875-74.25c37.5-52.5 31.5-123.37-13.875-168.74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounPhone);
export default __webpack_public_path__ + "static/media/noun-phone.6e6c4007e9f17c24df948bba9b2893ce.svg";
export { ForwardRef as ReactComponent };